import API from '../../../global/api';
import {getAdmins} from '../dashboard/dashboard.actions'


//Action types
export const DELETE_ADMIN= 'DELETE_ADMIN';
export const SELECTED_ADMIN= 'SELECTED_ADMIN';
export const DELETE_ADMIN_SUCCESS= 'DELETE_ADMIN_SUCCESS';
export const UPDATE_ADMIN_SUCCESS= 'UPDATE_ADMIN_SUCCESS';
export const ADD_ADMIN_SUCCESS= 'ADD_ADMIN_SUCCESS';




// Request Actions

export const selectedAdmin = (data) =>( {
  type : SELECTED_ADMIN,
  data: data
});

export const addAdminSuccess = (data) =>( {
  type : ADD_ADMIN_SUCCESS,
  data: data
});

const deleteAdminSuccess = (id) =>( {
  type : DELETE_ADMIN_SUCCESS,
  id: id
});

const updateAdminSuccess = () =>( {
  type : UPDATE_ADMIN_SUCCESS,
  // data: data
});


//Api calls
export const deleteAdmin= (id) => {
    return dispatch => {
    API.post(`/admin/delete-admin`,{id : id},{
    headers : {
      "Authorization" : `Bearer ${window.localStorage.getItem('auth_id')}`
    }
  })
  .then(res => {
      dispatch(getAdmins());
      dispatch(deleteAdminSuccess(id))
  })
}
};

export const updateAdmin= (data, oldData) => {
  return dispatch => {
  API.put(`/admin/update-admin`,
  {
  id: oldData.admin_user_id,
  email:data.email,
  password: data.password,
  lastName:data.last_name,
  firstName:data.first_name
 },{
  headers : {
    "Authorization" : `Bearer ${window.localStorage.getItem('auth_id')}`
  }
})
.then(res => {
    dispatch(getAdmins());
    dispatch(updateAdminSuccess())
})
}
};

export const addAdmin = (data) => {
  return dispatch => {
    API.post(`/admin/admin-register`,
      {
        email: data.email,
        password: data.password,
        lastName: data.last_name,
        firstName: data.first_name,
      }, {
      headers: {
        "Authorization": `Bearer ${window.localStorage.getItem('auth_id')}`
      }
    })
      .then(res => {
        dispatch(getAdmins());
      })
  }
};